
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader, Plus, Edit } from "lucide-react";
import { Form } from "@/components/dashboard/shops/types";
import { toast } from "sonner";

interface FormsListProps {
  forms: Form[];
  currentForm: Form | null;
  onSelectForm: (form: Form) => void;
  onCreateForm: () => boolean;
  isLoading: boolean;
}

export const FormsList: React.FC<FormsListProps> = ({
  forms,
  currentForm,
  onSelectForm,
  onCreateForm,
  isLoading
}) => {
  const handleCreateForm = () => {
    const result = onCreateForm();
    if (result) {
      toast.info("Nouveau formulaire créé", {
        description: "N'oubliez pas de cliquer sur 'Enregistrer' pour sauvegarder votre formulaire"
      });
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-medium">Mes formulaires</h3>
        <Button
          size="sm"
          onClick={handleCreateForm}
          className="flex items-center gap-1"
        >
          <Plus className="h-4 w-4" />
          Créer un formulaire
        </Button>
      </div>

      {forms.length === 0 ? (
        <div className="text-center py-6 bg-muted/50 rounded-md">
          <p className="text-muted-foreground">
            Vous n'avez pas encore créé de formulaire.
          </p>
        </div>
      ) : (
        <div className="space-y-2">
          {forms.map((form) => (
            <div
              key={form.id}
              className={`p-3 border rounded-md cursor-pointer hover:border-primary transition-colors ${
                currentForm?.id === form.id
                  ? "bg-primary/10 border-primary/30"
                  : "hover:bg-muted/60"
              }`}
            >
              <div className="flex justify-between items-center">
                <div>
                  <div className="font-medium">{form.name}</div>
                  <div className="text-sm text-muted-foreground">
                    {form.fields.filter(f => f.enabled).length}/{form.fields.length} champ(s) activé(s)
                  </div>
                </div>
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelectForm(form);
                  }}
                  className="text-primary hover:text-primary/90 hover:bg-primary/10"
                >
                  <Edit className="h-4 w-4 mr-1" />
                  Éditer
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
